<div
  class="flex w-full items-center justify-between h-[56px] border-b border-proffeo-border md:pl-16 pl-2 hover:bg-proffeo-surface-muted transition-default"
>
  <div class="flex w-[70%] md:w-[60%] gap-1 items-center pl-2">
    <div class="flex items-center gap-2">
      <div class="flex gap-3 items-center">
        <mat-icon
          fontIcon="group"
          class="icon-muted"
        />
        <p class="truncate max-sm:max-w-30 max-sm:text-sm">
          {{ group()?.name }}
        </p>
      </div>
    </div>
  </div>

  <div class="flex w-[40%] items-center">
    @if (groupAdmin()?.id) {
      <proffeo-avatar
        [user]="groupAdmin()"
        [style.z-index]="group()?.users()?.length"
        [borderType]="AvatarBorderType.IndustryAdmin"
        [size]="AvatarSize.SM"
      />
    }

    <proffeo-group-avatars
      (click)="selectGroupUsers()"
      [groupUsers]="users()"
      [showAvatarsCount]="2"
      [avatarSize]="AvatarSize.SM"
      class="cursor-pointer sm:ml-4"
    />
  </div>
</div>
